module.exports = __webpack_public_path__ + "img/honors-title.0ba4421a.png";